export default __webpack_public_path__ + "static/images/referral-4744d3836ed4b85fb2cb688a0d586069.jpg";